import { render, staticRenderFns } from "./AgendaBoxListPage.vue?vue&type=template&id=147eb712"
import script from "./AgendaBoxListPage.vue?vue&type=script&lang=js"
export * from "./AgendaBoxListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports